import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import { useRouter } from 'next/router';

import _ from 'lodash';

import { FadeInAnimation } from '../shared';

const ErrorResults = (props) => {   

    const {
        errorMessage,
    } = props;

    const router = useRouter();

    let message =
        `The server encountered an error and could not complete your request. 
         If the problem persists, please contact support and mention this error message: ${errorMessage}
         and explain what happened before the error occurred.`;

    let shallow = true;

    let buttonText = 'Back';

    const clearAllFilters = () => {
        router.push(
            {
                pathname: '/',
            },
            undefined,
            { shallow },
        );
    };

    return (
        <FadeInAnimation>
            <div className='no-results-container'>
                <h4 className='no-results-title'>Oh no!</h4>                
                <p className='no-results-description'>{message}</p>
                <Button
                    className="outline-button-white"
                    id="no-results-button"
                    onClick={clearAllFilters}
                >
                    {buttonText}
                </Button>
            </div>
        </FadeInAnimation>
    );
};

ErrorResults.propTypes = {
    errorMessage: PropTypes.string,
}

export default ErrorResults;
